import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const restoreRefuseReason = ({ _id }: { _id: string }): Promise<void> => {
  return axios.post(`/refuse-reasons/${_id}/restore`);
};

type UseRestoreRefuseReasonOptions = {
  config?: MutationConfig<typeof restoreRefuseReason>;
};

const TOAST_ID = 'restore-refuse-reason';

export const useRestoreRefuseReason = ({ config = {} }: UseRestoreRefuseReasonOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['refuse-reasons']);
      toasts.loadingToast.success(TOAST_ID, 'Refuse reason restored');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading(TOAST_ID, 'Restoring...');
      config.onMutate?.(...args);
    },
    mutationFn: restoreRefuseReason,
  });
};
